import { call, put, takeEvery, all } from 'redux-saga/effects'
import carrierTypes from './carrierInformationTypes'
import * as carrierAcions from './carrierInformationActions'
import CarrierInformation from '../../services/ProfileService/CarrierInformationService'
import notificationActions from '../notifications/notificationActions'

export function * get () {
  try {
    const { data = {} } = yield call(CarrierInformation.get)
    yield put(carrierAcions.getCarrierSuccess(data))
  } catch (error) {
    yield put(carrierAcions.getCarrierFailure(error.message))
  }
}

export function * update ({ payload }) {
  try {
    yield call(CarrierInformation.update, payload)
    yield put(carrierAcions.updateCarrierSuccess())
    yield put(notificationActions.SendToast({ message: 'Successfully update carrier information', type: 'success' }))
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message: 'Something went wrong and the information could not be updated.', type: 'error' }))
    yield put(carrierAcions.updateCarrierFailure(message))
  }
}

function * onGet () {
  yield takeEvery(carrierTypes.GET_CARRIER, get)
}
function * onUpdate () {
  yield takeEvery(carrierTypes.UPDATE_CARRIER, update)
}
export function * carrierInformtionSaga () {
  yield all([
    call(onGet),
    call(onUpdate)
  ])
}
